import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import { AccountingType } from 'v2-types/order';

export type GQLGetWireTransfers = {
  getTransfers: {
      reference: string
  }[]
};

export type GQLGetOrderAccounting = {
  getOrder: {
    accounting: AccountingType[] | null;
  };
};

export type OrderMember = {
  kind: string;
  name: string;
  login_email: string;
}

export type GQLGetOrderMember = {
  getParty: {
    name: string;
    members: OrderMember[];
  };
};

export const getWireTrannsfersResponse = async (payload: {
  orderId: string;
}) => {
  const query = gql`
    query GetTransfers($orderId: String!) {
      getTransfers(order_id: $orderId) {
        reference
      }
    }
  `;

  const response = await graphQLClient().request<GQLGetWireTransfers>(
    query,
    payload
  );
  return response;
};

export type GQLGetBlockchainData = {
  getBlockchainData: boolean
};

export const getBlockchainData = async (payload: {
  dataId: string,
  references?: string[]
}) => {
  const referencesParam = payload.references ? "$references: [String!]!" : "";
  const referencesVariableSet = payload.references ? `references: $references` : "";

  const query = gql`
    query GetBlockchainData($dataId: String!, ${referencesParam}) {
      getBlockchainData(data_id: $dataId, ${referencesVariableSet})
    }
  `;

  const response = await graphQLClient().request<GQLGetBlockchainData>(
    query,
    payload
  );
  return response;
};

export type GQLGetBlockchainAuditData = {
  getBlockchainAudit: boolean
};

export const getBlockchainAuditData = async (payload: {
  dataId: string,
  reference: string
}) => {
  const query = gql`
    query GetBlockchainAuditData($dataId: String!, $reference: String) {
      getBlockchainAudit(data_id: $dataId, reference: $reference)
    }
  `;

  const response = await graphQLClient().request<GQLGetBlockchainAuditData>(
    query,
    payload
  );
  return response;
};

export const getAccountingData = async (payload: { id: string }) => {
  const query = gql`
    query GetOrder($id: ID!) {
      getOrder(_id: $id) {
        accounting {
          _id
          involved_parties {
            _id
            amount
            kind
            name
            payment_kind
            payment_reference
          }
          description
          kind
          code
        }
      }
    }
  `;

  const response = await graphQLClient().request<GQLGetOrderAccounting>(
    query,
    payload
  );
  return response;
};

export const getMembesrTitle = async (payload: { id: string }) => {
  const query = gql`
    query GetParty($id: ID!) {
      getParty(_id: $id) {
        name
        members {
          kind
          name
          login_email
        }
      }
    }
  `;

  const response = await graphQLClient().request<GQLGetOrderMember>(
    query,
    payload
  );
  return response;
};
